import { createAction } from '@reduxjs/toolkit';

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const sendMessageAction = createAction(SEND_MESSAGE, (messageData) => ({
  payload: messageData
}));